// (perf5) Live-data commit gate.
//
// useChartData publishes market data to React (stats / recentTrades /
// chartData) once per animation frame while trades flow. On a futures pair
// three merged venue streams keep that at ~60 commits/s, and every commit is
// a full App + FootprintChart render (new chartData.candles array -> fresh
// visibleCandles -> VP / absorption / grid memo passes, a second yCam.frame()
// per frame, React text writes, a full compositor re-layerize). During a Y
// zoom glide that work lands in the same frames as the glide steps — the
// futures-only stutter.
//
// A chart registers a predicate here ("my Y glide is walking"). While any
// predicate is true, useChartData keeps ingesting trades into its refs (the
// forming candle is mutated in place, so the per-frame canvas draw still
// shows it) but HOLDS the React commits, then flushes them once the glide
// lands (capped — see DATA_HOLD_MAX_MS in useChartData).
//
// Predicates, not begin/end calls: nothing has to be released on every
// glide exit path (land, cancel, unmount) — the hold ends by itself the
// moment the predicate reads false.
//
// (chart2-bounce) PER SLOT. This used to be one process-wide set, so a glide
// on chart 1 held chart 2's commits too (and the reverse). The chart that was
// NOT gliding does not redraw every frame, so its candles, stats and tape sat
// still and then jumped up to a second's worth at once whenever the other
// chart zoomed. A hold now names its slot (chartId) and a data hook only
// waits on holds registered for its own slot. A null/undefined key keeps the
// old global behaviour for any caller that does not pass one.
const holds = new Map()   // pred -> slot key (or null = every slot)

export function registerDataHold(pred, slot = null) {
  holds.set(pred, slot == null ? null : String(slot))
  return () => { holds.delete(pred) }
}

export function dataCommitsHeld(slot = null) {
  const k = slot == null ? null : String(slot)
  for (const [p, s] of holds) {
    if (k != null && s != null && s !== k) continue
    try { if (p()) return true } catch { /* a dead chart never holds */ }
  }
  return false
}
